import { render, staticRenderFns } from "./LogoGrid.vue?vue&type=template&id=c595bc72"
import script from "./LogoGrid.vue?vue&type=script&lang=js"
export * from "./LogoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports